import { useEffect, useRef } from 'react';

import styled from 'styled-components';

import MMLoader from '~/src/common/components/Loader';

const Loader = styled(MMLoader)`
  margin: 0;
`;

interface Props<T> {
  loadMore: () => Promise<T> | void;
  isError: boolean;
  isFetching: boolean;
  hasMore?: boolean;
}

const LoadMore = <T,>({ loadMore, isError, isFetching, hasMore = false }: Props<T>) => {
  const loadMoreRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Configuration de l'observer
    const options = { threshold: 1 };
    const handler = (entries: IntersectionObserverEntry[]) => {
      entries.forEach(entry => entry.isIntersecting && void loadMore());
    };
    // Surveillance du div invisible <LoadMore />
    const observer = new IntersectionObserver(handler, options);
    if (loadMoreRef.current) observer.observe(loadMoreRef.current);
    return () => observer.disconnect();
  }, [loadMore]);

  const showLoader = !isError && isFetching;
  const showLoadMore = !isError && !isFetching && hasMore;

  return (
    <>
      {showLoadMore && <div ref={loadMoreRef} style={{ height: '1px' }} />}
      {showLoader && <Loader />}
    </>
  );
};

export default LoadMore;
